import React from "react";
import { Route, Switch } from "react-router-dom";
import routes from "../../config/routes/routes";
import PageNotFound from "../App/404";

const BusinessDevAndPartnerShipsLayout = () => {
  return (
    <div className="d-flex">
      <Switch>
        <Route
          exact
          path={routes.businessDevelopmentAndPartnerships.donors.path}
          component={routes.businessDevelopmentAndPartnerships.donors.component}
        />
        <Route
          exact
          path={
            routes.businessDevelopmentAndPartnerships.donors.donorDetails.path
          }
          component={
            routes.businessDevelopmentAndPartnerships.donors.donorDetails
              .component
          }
        />
        <Route
          exact
          path={routes.businessDevelopmentAndPartnerships.projects.path}
          component={
            routes.businessDevelopmentAndPartnerships.projects.component
          }
        />
        <Route
          exact
          path={
            routes.businessDevelopmentAndPartnerships.projects.projectDetails
              .path
          }
          component={
            routes.businessDevelopmentAndPartnerships.projects.projectDetails
              .component
          }
        />
        <Route
          exact
          path={routes.businessDevelopmentAndPartnerships.strategicPlans.path}
          component={
            routes.businessDevelopmentAndPartnerships.strategicPlans.component
          }
        />
        <Route
          exact
          path={
            routes.businessDevelopmentAndPartnerships.activityConceptNotes.path
          }
          component={
            routes.businessDevelopmentAndPartnerships.activityConceptNotes
              .component
          }
        />
        <Route
          exact
          path={
            routes.businessDevelopmentAndPartnerships
              .childProtectionIncidentForms.path
          }
          component={
            routes.businessDevelopmentAndPartnerships
              .childProtectionIncidentForms.component
          }
        />

        <Route
          exact
          path={routes.businessDevelopmentAndPartnerships.allActionPoints.path}
          component={
            routes.businessDevelopmentAndPartnerships.allActionPoints.component
          }
        />
        <Route
          exact
          path={routes.businessDevelopmentAndPartnerships.activityReports.path}
          component={
            routes.businessDevelopmentAndPartnerships.activityReports.component
          }
        />
        <Route
          exact
          path={routes.businessDevelopmentAndPartnerships.beneficiaries.path}
          component={
            routes.businessDevelopmentAndPartnerships.beneficiaries.component
          }
        />
        <Route>
          <PageNotFound />
        </Route>
      </Switch>
    </div>
  );
};

export default BusinessDevAndPartnerShipsLayout;
